@if (items.length) {
  <div class="tag-selection-wrapper">
    @for (tag of items; track tag.key; let last = $last) {
      <div class="tag-item" [class.active]="tag.active" [class.last]="last" (click)="toggleActive(tag)">
        {{ tag.key | translate }}
      </div>
    }
    <div class="tag-resetter" [class.active]="activeItems.length" (click)="resetFilters()">
      {{ 'RESET_SELECTION' | translate }}
    </div>
    <div class="tag-right-spacer"></div>
  </div>
}
